import React, { forwardRef } from 'react';
import { IMaskInput, IMask } from 'react-imask';
import { TextMaskCustomProps } from './types';

export const TextMaskCustom = React.memo(
    forwardRef<HTMLElement, TextMaskCustomProps>((props, ref) => {
        const { onChange, ...other } = props;

        return (
            <IMaskInput
                {...other}
                mask="HH:MM"
                definitions={{
                    'H': {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 2
                    },
                    'M': {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 5
                    }
                }}
                blocks={{
                    'HH': {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 24,
                        maxLength: 2
                    },
                    'MM': {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 59,
                        maxLength: 2
                    }
                }}
                prepare={(value: string, masked: any) => {
                    // Si se intenta ingresar un valor con hora 24 y minutos distintos de 00, rechazarlo
                    const parts = value.split(':');
                    if (parts.length === 2) {
                        const hours = parseInt(parts[0], 10);
                        const minutes = parseInt(parts[1], 10);

                        if (hours === 24 && minutes > 0) {
                            // Si es 24:XX donde XX > 00, forzar a que sea 24:00
                            return '24:00';
                        }
                    }
                    return value;
                }}
                validate={(value: string, { blocks }: { blocks: any }) => {
                    const parts = value.split(':');
                    if (parts.length === 2) {
                        const hours = parseInt(parts[0], 10);
                        const minutes = parseInt(parts[1], 10);

                        // Si es 24:XX donde XX > 00, rechazar
                        if (hours === 24 && minutes > 0) {
                            return false;
                        }
                    }
                    return true;
                }}
                placeholder={'24:00'}
                inputRef={ref}
                onAccept={(value: string) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: value,
                        },
                    });
                }}
                onInput={(e: any) => {
                    // Capturar cambios en tiempo real
                    const value = e.target.value;
                    onChange({ target: { name: props.name, value } });
                }}
                overwrite
            />
        );
    })
);

TextMaskCustom.displayName = 'TextMaskCustom';
